export default {
  props: {
    allowClickOnMobile: Boolean
  }
}